import { Token } from "~/modules/assets/types";

// // // //

/**
 * Finds the most common platform across native tokens by occurrence count.
 * Returns `null` when no native tokens have platform data.
 */
export function getDominantPlatform(tokens: Token[]): Token["platform"] | null {
    const platformCounts = new Map<
        string,
        { count: number; platform: Token["platform"] }
    >();

    for (const token of tokens) {
        if (token.issuance_type !== "NATIVE") continue;
        if (!token.platform) continue;
        const platformId = String(token.platform.id);
        const existing = platformCounts.get(platformId);
        if (!existing) {
            platformCounts.set(platformId, {
                count: 1,
                platform: token.platform,
            });
        } else {
            platformCounts.set(platformId, {
                count: existing.count + 1,
                platform: existing.platform,
            });
        }
    }

    if (platformCounts.size === 0) return null;

    return Array.from(platformCounts.values()).reduce((max, current) =>
        current.count > max.count ? current : max,
    ).platform;
}
